import styled from 'styled-components';

export const SearchButton = styled.div`
  background: transparent;
`;


export const SearchPanelDiv = styled.div`
  position: fixed;
  top: 81px;
  left: 0;
  width: 100%;
  /* background: #000; */

  height: calc(100vh - 81px);
  background: url('/images/search/bg.jpg') no-repeat center;
  background-size: cover;
  z-index: 10;

  .form {
    max-width: 894px;
    width: 90%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    
    form {
      background: #fff;
      border-radius: 100px;
      display: flex;
      .icon {
        margin: 0 18px;
      }
      input {
        display: block;
        width: 100%;
        height: 50px;
        padding: 0 0;
        box-sizing: border-box;
        outline: 0;
      }
      button {
        padding: 0 18px;
      }
    }

    .keywords {
      padding: 60px 0 0 0;
      h1 {
        font-size: 1.5rem;
        color:  ${(props) => props.theme.colors.b.wh};
        font-weight: bold;
        padding: 0 0 24px 0;
      }
      ul {
        li {
          display: inline-block;
          padding: 8px 4px;
          button {
            padding: 12px 20px;
            font-size: 1.25rem;
            color:  ${(props) => props.theme.colors.b.wh};
            border: 1px solid  ${(props) => props.theme.colors.b.wh};
            border-radius: 100px;
          }
        }
      }
    }
  }

  .close {
    position: absolute;
    top: 20px;
    right: 20px;
  }
`;